export enum AuditTrailActionEnum {
    Uncategorised = "Action_Uncategorised",
    EditStudy = "Action_EditStudy",
    EditSite = "Action_EditSite",
    EditSubject = "Action_EditSubject",
    EditVisit = "Action_EditVisit",
    EditSession = "Action_EditSession",
    AddSite = "Action_AddSite",
    AddSubject = "Action_AddSubject",
    CreateDevice = "Action_CreateDevice",
    AddSession = "Action_AddSession",
    DeleteStudy = "Action_DeleteStudy",
    DeleteSite = "Action_DeleteSite",
    DeleteSubject = "Action_DeleteSubject",
    DeleteVisit = "Action_DeleteVisit",
    DeleteSession = "Action_DeleteSession",
    ViewStudy = "Action_ViewStudy",
    ViewSite = "Action_ViewSite",
    ViewSubject = "Action_ViewSubject",
    ViewVisit = "Action_ViewVisit",
    ViewSession = "Action_ViewSession",
    CreateStudy = "Action_CreateStudy",
    CreateSite = "Action_CreateSite",
    CreateSubject = "Action_CreateSubject",
    CreateVisit = "Action_CreateVisit",
    CreateSession = "Action_CreateSession",
    AddSessionNote = "Action_AddSessionNote",
    AllocateDeviceToSite = "Action_AllocateDeviceToSite",
    ImportSites = "Action_ImportSites",
    UpdateStudySettings = "Action_UpdateStudySettings",
    AllocateDeviceToSubject = "Action_AllocateDeviceToSubject",
    DeleteAllocation = "Action_RemoveAllocation",
    AddSubjectNote = "Action_AddSubjectNote",
    MarkCoughEvent = "Action_MarkCoughEvent",
    ImportCoughEvents = "Action_ImportCoughEvents",
    ReceiveCFcard = "Action_ReceiveCFcard",
    RemoveCoughEvent = "Action_RemoveCoughEvent",
    DownloadFile = "Action_DownloadFile",
    DeleteFile = "Action_DeleteFile",
    UpdateContatcInformation = "Action_UpdateContactInformation",
    ModifyComments = "Action_ModifiedComments",
    SaveEventForStudy = "Action_SaveCoughEvent",
    ResetCoughAnalysis = "Action_ResetCoughAnalysis",
    ReopenCoughSession = "Action_ReopenCoughSession",
    UpdatedSessionTrackingNumber = "Action_UpdateSessionTrackingNumber",
    UnassignDeviceFromSession = "Action_UnassignDeviceFromSession",
    UnassignDeviceAllocation = "Action_UnassignDevice",
    ImportDevice = "Action_ImportDevice",
    CreateEdiaryConfiguration = "Action_CreateEdiaryConfiguration",
    ModifyEdiaryConfiguration = "Action_ModifyEdiaryConfiguration",
    DeleteEdiaryConfiguration = "Action_DeleteEdiaryConfiguration",
    UploadFileForEdiaryConfiguration = "Action_UploadFileForEdiaryConfiguration",
    DeleteFileForEdiaryConfiguration = "Action_DeleteFileForEdiaryConfiguration",
    CreateAlert = "Action_CreateAlert",
    TriggerAlert = "Action_TriggerAlert",
    MarkAlertAsRead = "Action_MarkAlertAsRead",
    SaveSitePerformance = "Action_SaveSitePerformance",
    CompleteSitePerformanceTest = "Action_CompleteSitePerformanceTest",
    CreateRole = "Action_CreateRole",
    ModifyPermissionForRole = "Action_ModifyPermissionForRole",
    ImportRolePermission = "Action_ImportRolePermission",
    ModifyReportForRole = "Action_ModifyReportForRole",
    ModifyRoleForRole = "Action_ModifyRoleForRole",
    AddReportForSubject = "Action_AddReportForSubject",
    UpdateGeneralSettings = "Action_UpdateGeneralSettings",
    ConfigureVitaloJAKDeviceButtons = "Action_ConfigureVitaloJAKDeviceButtons",
    ModifyCustomisationForStudy = "Action_ModifyCustomisationForStudy",
    ImportStudySettings = "Action_ImportStudySettings",
    CompletingImportStudySettings = "Action_CompletingImportStudySettings",
    OverreadSessionReceivedBySpirotrac = "Action_OverreadSessionRecievedBySpirotrac",
    SaveVisitSchedule = "Action_SaveVisitSchedule",
    EditPopulationGroup = "Action_EditPopulationGroup",
    DeletePopulationGroup = "Action_DeletePopulationGroup",
    CreatePopulationGroupForStudy = "Action_CreatePopulationGroupForStudy",
    CreatePopulationGroupWithCoreRace = "Action_CreatePopulationGroupWithCoreRace",
    ProcessingFile = "Action_ProcessingFile",
    RunManchesterAlgorithm = "Action_RunManchesterAlgorithm",
    MarkFileAsQualityCheck = "Action_MarkFileAsQualityCheck",
    MapDeviceEventstoWaveform = "Action_MapDeviceEventsToWaveform",
    StoreProcessedWavFile = "Action_StoreProcessedWavFile",
    ImportDataFromDevice = "Action_ImportDataFromDevice",
    UploadFileToServer = "Action_UploadFileToServer",
    FinishUploadFile = "Action_FinishUploadFile",
    RegisterDevice = "Action_RegisterDevice",
    ImportUser = "Action_ImportUsers",
    AssocieateUserWithSite = "Action_AssociateUserWithSite",
    AddCoughEvent = "Action_AddCoughEvent",
    AddWeeklyQAEvent = "Action_AddWeeklyQAEvent",
    AddAnalysisSet = "Action_AddAnalysisSet",
    UpdateAnalysisSet = "Action_UpdateAnalysisSet",
    AssignAnalysisSetToUser = "Action_AssignAnalysisSetToUser",
    UpdateAnalysisSetStartDate = "Action_UpdateAnalysisSetStartDate",
    ReopenAnalysisSet = "Action_ReopenAnalysisSet",
    ToggleFixedComments = "Action_ToggleFixedComments",
    SelectStudyThreshold = "Action_SelectStudyThreshold",
    UploadFileCollection = "Action_UploadFileToCollection",
    RemoveMappedServerDirectory = "Action_RemoveMappedServerDirectory",
    AddMappedServerDirectory = "Action_AddMappedServerDirectory",
    RunStudyQAMetric = "Action_RunStudyQAMetric",
    CreateStudyQAMetric = "Action_CreatStudyQAMetric",
    ImportService = "Action_ImportService",
    UserSignedIn = "Action_UserSignedIn",
    EditUser = "Action_EditUser",
    RegisterUser = "Action_RegisterUser",
    CreateFixedCommentSet = "Action_CreateOverreadCommentSet",
    EditFixedCommentSet = "Action_EditOverreadCommentSet",
    GetTimeZoneInfo = "Action_GetTimeZoneInfo",
    UpsertSSRSReportUserVariables = "Action_UpsertSSRSReportUserVariables",
    GetSetupInfo = "Action_GetSetupInfo",
    CreateDeviceResources = "Action_CreateDeviceResources",
    EditDeviceResources = "Action_EditDeviceResources",
    DeleteDeviceResources = "Action_DeleteDeviceResources",
    BindVCDModel = "Action_BindVCDModel",
    ImportVitaloJAKFiles = "Action_ImportVitaloJAKFiles",
    BeginAnalysis = "Action_BeginAnalysis",
    CreateMediaPostalRecord = "Action_CreateMediaPostalRecord",
    SaveReportBytes = "Action_SaveReportBytes",
    BuildP230Configuration = "Action_BuildP230Configuration",
    RevealPin = "Action_RevealPin",
    UserForgotPassword = "Action_UserForgotPassword",
    UserSignedOut = "Action_UserSignedOut",
    ResetPassword = "Action_ResetPassword",
    EditUserSettings = "Action_EditUserSettings",
    SelectRolesForUser = "Action_SelectRolesForUser",
    AddBloodGlucoseSession = "Action_AddBloodGlucoseSession",
    AddBloodGlucoseTest = "Action_AddBloodGlucoseTest",
    EditBloodGlucoseSession = "Action_EditBloodGlucoseSession",
    BloodGlucoseTestsAcceptedByTechnician = "Action_BloodGlucoseTestsAcceptedByTechnician",
    FinalizeBulkUpload = "Action_BulkUploadFinalized",
    AddCoughSession = "Action_AddCoughSession",
    UpdateCoughSessionMetadata = "Action_UpdateCoughSessionMetadata",
    UserChangedPassword = "Action_UserChangedPassword",
    UserChangedEmailAddress = "Action_UserChangedEmailAddress",
    UserConfirmedEmailAddressChangeWithToken = "Action_UserConfirmedEmailAddressChange",
    RemoveRolesFromUser = "Action_RemoveRolesFromUser",
    ResetUserAccessFailedCount = "Action_ResetUserAccessFailedCount",
    UserChangedPasswordAfterExpiry = "Action_UserChangedPasswordAfterExpiry",
    DataCorrectionRequested = "Action_DataCorrectionRequest",
    SavedAttachmentsToFileSystem = "Action_SavedAttachmentsToFileSystem",
    AttachmentDownloadedFromFileSystem = "Action_AttachmentDownloadedFromFileSystem",
    PrimaryAnalysisSetsModified = "Action_PrimaryAnalysisSetsModified",
    GeneratedUploadReport = "Action_GeneratedUploadReport",
    Seeding = "Action_SeedDatabase",
    OverreadSessionReturnedToSpirotrac = "Action_OverreadSessionReturnedToSpirotrac",
    CoughSessionReprocessingReset = "Action_CoughSessionResetForReprocessing",
    UpdateCoughAnalysisSetReopenReason = "Action_UpdateCoughAnalysisSetReopenReason",
    UserPasswordExpired = "Action_UserPasswordExpired",
    AddReport = "Action_ReportAdded",
    DeleteReport = "Action_ReportDeleted",
    UpdatedTechnicianTestAcceptability = "Action_TechnicianTestAcceptabilityUpdated",
    RejectedOverreaderTestAcceptability = "Action_TechnicianRejectedTestAcceptability",
    CreateDemographicSet = "Action_CreateDemographicSet",
    CreateSpirometryTest = "Action_CreateSpirometryTest",
    EditSpirometryTest = "Action_EditSpirometryTest",
    UpdatedSessionConfiguredState = "Action_UpdatedSessionConfiguredState",
    SetCurrentTechnicianNote = "Action_SetCurrentTechnicianNote",
    QCAnalysisSetCreated = "Action_QCAnalysisSetForSession",
    ReassignAnalysisSet = "Action_ReassignAnalysisSet",
    CreateDlcoTest = "Action_CreateDlcoTest",
    EditDlcoTest = "Action_EditDlcoTest",
    CreateCalibration = "Action_CreateCalibration",
    EditCalibration = "Action_EditCalibration",
    ReviewRequired = "Action_ToggleQARequired",
    LinkAnalysisSet = "Action_AddLinkAnalysisSet",
    RemoveLinkedAnalysisSet = "Action_RemoveLinkAnalysisSet",
    ReImportDeviceEvents = "Action_ReImportDeviceEvents",
    CreateSpirometryQCBatch = "Action_CreateSpirometryQCBatch",
    ReviewComplete = "Action_CoughReviewComplete",
    UpdateCoughAnalysisSetReviewComments = "Action_UpdateCoughAnalysisSetReviewComments",
    ResetCoughAnalysisSetReview = "Action_ResetCoughAnalysisSetReview",
    ReopenAnalysisSetDuringReview = "Action_ReOpenAnalysisSetDuringReview",
    CalculatedSpirometrySiteBestValues = "Action_CalculatedSpirometrySiteBestValues",
    CalculatedDLcoSiteBestValues = "Action_CalculatedDLcoSiteBestValues",
    AnalysisBatchDeleted = "Action_AnalysisBatchDeleted",
    ChangeQACreatedFrom = "Action_ChangeCoughQACreatedFrom",
    CreateSixMinuteWalkTest = "Action_CreateSixMinuteWalkTest",
    EditSixMinuteWalkTest = "Action_EditSixMinuteWalkTest",
    MiscFieldsUpsert = "Action_MiscFieldsUpserted",
    ImportDeviceAuditTrailEntries = "Action_DeviceAuditEntriesImported",
    BorgScaleCreated = "Action_CreateBorgScale",
    CreateEdiaryPackageDeployment = "Action_CreateEdiaryPackageDeployment",
    CreateDiaryTest = "Action_CreateDiaryTest",
    EditDiaryTest = "Action_EditDiaryTest",
    DeleteEdiaryPackageDeployment = "Action_DeleteEdiaryPackageDeployment",
    DiaryComplianceEdited = "Action_DiaryComplianceEdited",
    UpdatedSessionSuppressedState = "Action_UpdatedSessionSuppressedState",
    CreateEcgTest = "Action_CreateEcgTest",
    EditEcgTest = "Action_EditEcgTest",
    CreateFixedComment = "Action_CreateFixedComment",
    EditFixedComment = "Action_EditFixedComment",
    DeleteFixedComment = "Action_DeleteFixedComment",
    SetSubjectRandomizedState = "Action_SetSubjectRandomizedState",
    UndoSubjectRandomizedState = "Action_UndoSubjectRandomizedState",
    EditDevice = "Action_EditDevice",
    DeletedDevice = "Action_DeleteDevice",
    SuccessfulManualResetIn2itiveDiary = "Action_SuccessfulManualResetIn2itiveDiary",
    UnsuccessfulManualResetIn2itiveDiary = "Action_UnsuccessfulManualResetIn2itiveDiary",
    LaunchCalibrationVerification = "Action_LaunchCalibrationVerification",
    ConfirmedValidDuplicates = "Action_ConfirmedValidDuplicates",
    StartedUsbUploadIn2itiveDiary = "Action_StartedUsbUploadIn2itiveDiary",
    CompletedUsbUploadIn2itiveDiary = "Action_CompletedUsbUploadIn2itiveDiary",
    EditSessionNote = "Action_EditSessionNote",
    EditTestNote = "Action_EditTestNote",
    EditSubjectNote = "Action_EditSubjectNote",
    RepeatabilityCalculated = "Action_RepeatabilityCalculated",
    BatchProcessCoughSessionsTriggered = "Action_BatchProcessCoughSessionsTriggered",
    ViewReport = "Action_ViewReport"
}
